/**
 * Найти индекс начала цитируемой истории в HTML-теле письма (для сворачивания под «···»).
 * Возвращает индекс в строке html или -1, если граница не найдена.
 * Ищем первый из распространённых маркеров цитаты; берём самый ранний.
 */
export function findHtmlQuoteSplit(html) {
  if (!html) return -1;
  const markers = [
    /<div[^>]*class="[^"]*gmail_quote[^"]*"/i,
    /<blockquote/i,
    /<hr\b[^>]*>\s*(?=(?:<[^>]+>\s*)*(?:from:|от:|on\s|sent:))/i,
    /<div[^>]*class="[^"]*(?:gmail_extra|yahoo_quoted|moz-cite-prefix)[^"]*"/i,
    // «From:»/«Sent:»/«On … wrote:» как начало абзаца/блока
    /(?:<(?:p|div)[^>]*>\s*)(?:from:|от:|on\s+[a-zа-я,].*?wrote:)/i,
  ];
  let best = -1;
  for (const re of markers) {
    const m = re.exec(html);
    if (m && (best === -1 || m.index < best)) best = m.index;
  }
  return best;
}
